import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  FormGroup,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  // CloseIcon,
  styled,
  AddIcon
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";



import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "patients";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paper': {
    minWidth: '80%'
  }
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large">
          {/* <CloseIcon /> */}
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LabResults = ({ open, handleClose, labResultData, handleChangeByTabs, handleSubmitByTabs, handleRDateChangeByTabs, errorLabResultsData }) => {

  const LABTest_List =JSON.parse(localStorage.getItem("LABTest_List"));
  const Location_List =JSON.parse(localStorage.getItem("FacilityLocation"));

//get DispensingLanguage



  const classes = useStyles();
  const { t, i18n } = useTranslation();
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>

{DispensingLanguage[lan][menukey]['LAB RESULTS ENTRY'] } - {labResultData.id ? (DispensingLanguage[lan][menukey]['EDIT']) : (DispensingLanguage[lan][menukey]['ADD']) } 

        </BootstrapDialogTitle>
        <DialogContent dividers>
          {/* <Typography gutterBottom>
						Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
						dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
						consectetur ac, vestibulum at eros.
					</Typography> */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl variant="standard" className={classes.fullWidth}>
                <InputLabel id="demo-simple-select-helper-label"> {DispensingLanguage[lan][menukey]['Test Name']} </InputLabel>
                <Select
                  required
                  error={!!errorLabResultsData.testCode}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  name="testCode"
                  value={labResultData.testCode}
                  fullWidth
                  onChange={(e) => handleChangeByTabs(e, "labResultsData")}
                label={DispensingLanguage[lan][menukey]['Test Name']}>
                  {
                    LABTest_List.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    })
                  }
                </Select>
                <FormHelperText error={!!errorLabResultsData.testCode}>{errorLabResultsData.testCode}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField variant="standard"
                id="testResult"
                name="testResult"
                label= { DispensingLanguage[lan][menukey]['Test Result'] }
                value={labResultData.testResult}
                type="number"
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "labResultsData")}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                                <DatePicker
                    label= { DispensingLanguage[lan][menukey]['Test Date'] }
                    value={labResultData.testDate || new Date()}
                    inputFormat="dd/MM/yyyy"
                    onChange={(e) => handleRDateChangeByTabs(e, "testDate", "labResultsData")}
                                    renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      className={classes.fullWidth}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>

            <FormControl variant="standard" className={classes.fullWidth}>
                {/* <InputLabel id="demo-simple-select-helper-label"> {DispensingLanguage[lan][menukey]['Test Name']} </InputLabel>
                <Select
                  required
                  error={!!errorLabResultsData.testCode}
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  name="testCode"
                  value={labResultData.testCode}
                  fullWidth
                  onChange={(e) => handleChangeByTabs(e, "labResultsData")}
                label={DispensingLanguage[lan][menukey]['Test Name']}>
                  {
                    LABTest_List.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    })
                  }
                </Select>
                <FormHelperText error={!!errorLabResultsData.testCode}>{errorLabResultsData.testCode}</FormHelperText>
              */}


              {/* <TextField
                id="place"
                name="place"
                label= { DispensingLanguage[lan][menukey]['Place'] }
                value={labResultData.place}
                fullWidth
                autoComplete="family-name"
                onChange={(e) => handleChangeByTabs(e, "labResultsData")}
              /> */}

                  <InputLabel id="Location-select-helper-label"> {DispensingLanguage[lan][menukey]['Place']} </InputLabel>
                  <Select
                  
                  error={!!errorLabResultsData.LocationId}
                  labelId="Location-select-helper-label"
                  id="Location-select-helper"
                  name="LocationId"
                  value={labResultData.LocationId}
                  fullWidth
                  onChange={(e) => handleChangeByTabs(e, "labResultsData")}
                label={DispensingLanguage[lan][menukey]['Place']}>
                  {
                    Location_List.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    })
                  }
                </Select>
                </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
           autoFocus
           className="float-start" 
           variant="contained"
           color="gray"
           onClick={handleClose} >
          { DispensingLanguage[lan][menukey]['Cancel'] }
          </Button>
          <Button 
            autoFocus  
            className="me-2 float-start"
            variant="contained"
            color="primary" 
            onClick={() => handleSubmitByTabs("labResultsData")}>
          { DispensingLanguage[lan][menukey]['Save changes'] } 
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  )
}

export default LabResults;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});